import React, { useEffect } from "react"
import "./Layout.css"
import AldooBoot from "aldoo-ra/Boot"
import Site from "../components/Site"
import { navigate } from "vike/client/router"
import { VariantProvider } from "aldoo-ra/VariantReader/VariantContext.jsx"
import { usePageContext } from "vike-react/usePageContext"

// Add project-specific local variant overrides here, e.g.:
// import TypographyVariants from "../components/Variants/Typography.jsx"
// const localVariants = { Typography: TypographyVariants }
const localVariants = {}

// Merge SSR/CMS variants with local file variants.
// Local variants fill in any empty or missing values from the server,
// so bad/incomplete CMS data never overrides correct local definitions.
function mergeWithLocalFallback(ssrVariants) {
  const result = {}
  const names = new Set([
    ...Object.keys(ssrVariants || {}),
    ...Object.keys(localVariants),
  ])
  for (const name of names) {
    const server = ssrVariants?.[name] || {}
    const local = localVariants[name] || {}
    const merged = { ...server }
    for (const [key, value] of Object.entries(local)) {
      if (!merged[key]) merged[key] = value
    }
    result[name] = merged
  }
  return result
}

export function Layout({ children }) {
  const pageContext = usePageContext()
  const variants = mergeWithLocalFallback(pageContext.ssrVariants)

  useEffect(() => {
    const handlePopState = (event) => {
      navigate(window.location.pathname + window.location.search, { overwriteLastHistoryEntry: true })
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  return (
    <React.StrictMode>
      <VariantProvider ssrVariants={variants}>
        <AldooBoot />
        <Site>{children}</Site>
      </VariantProvider>
    </React.StrictMode>
  )
}
